import React, { useEffect, useState } from 'react';
import Select from 'react-select';

const EntityTab = () => {

const [showExtraEntity, setShowExtraEntity] = useState(false);
const [showMasterShipper, setShowMasterShipper] = useState(false);
const [showCustomBroker, setShowCustomBroker] = useState(false);
const [showSecondNotify, setShowSecondNotify] = useState(false);
const [showThirdNotify, setShowThirdNotify] = useState(false);
const [showTransporter, setShowTransporter] = useState(false);
const [showShipTo, setShowShipTo] = useState(false);
const [showBookingParty, setShowBookingParty] = useState(false);
const [showSeller, setShowSeller] = useState(false);
const [showImporter, setShowImporter] = useState(false);
const [showBuyer, setShowBuyer] = useState(false);
const [showCertifiter, setShowCertifiter] = useState(false);

useEffect(() => {
if (
showShipTo === true ||
showImporter === true ||
showBookingParty === true ||
showBuyer === true ||
showSeller === true ||
showTransporter === true
) {
setShowExtraEntity(true);
} else {
setShowExtraEntity(false);
}
}, [showShipTo, showImporter, showBookingParty, showBuyer, showSeller, showTransporter]);

const shipperOptions = [
{ value: 1, label: "Rohit" },
{ value: 2, label: "Ravi" },
{ value: 3, label: "Sakshi" },
{ value: 4, label: "Abhishek" },
{ value: 5, label: "Shweta" },
];

return (
<>
    <form>
        <div className="row border-bottom-2 pb-3">
            <div className="col-md-12">
                <div className=" py-2">
  <div className="row">
      {/* Job No. */}
      <div className="col-md-6">
        <div className="card d-flex flex-row p-3 align-items-baseline">
          <label htmlFor="JobNo" className="form-label mx-2">Job No.</label>
          <div className="flex-grow-1 d-flex flex-column">
            <div className="d-flex">
              <input
                type="text"
                id="JobNoPrefix"
                className="form-control"
                placeholder="GEN/"
                style={{ width: "20%" }}
              />
              <input
                type="text"
                id="JobNoBody"
                className="form-control mx-1"
                placeholder="-----New-----"
                style={{ width: "60%" }}
              />
              <input
                type="text"
                id="JobNoSuffix"
                className="form-control"
                placeholder="/24-25"
                style={{ width: "20%" }}
              />
            </div>
          </div>
          <i className="fa fa-search mx-2"></i>
        </div>
      </div>

      {/* Job Order */}
      <div className="col-md-6">
        <div className="card d-flex flex-row p-3 align-items-baseline">
          <label htmlFor="JobOrder" className="form-label mx-2">Job Order</label>
          <div className="flex-grow-1">
            <input type="text" id="JobOrder" className="form-control" />
          </div>
        </div>
      </div>

      {/* Job Type */}
      <div className="col-md-6">
        <div className="card d-flex flex-row p-3 align-items-baseline">
          <label htmlFor="JobType" className="form-label mx-2">Job Type</label>
          <div className="flex-grow-1">
            <select id="JobType" className="form-select">
              <option>Select Type</option>
            </select>
          </div>
        </div>
      </div>

      {/* Organization Ref No. */}
      <div className="col-md-6">
        <div className="card d-flex flex-row p-3 align-items-baseline">
          <label htmlFor="OrganizationRef" className="form-label mx-2">
            Organization Ref No.
          </label>
          <div className="flex-grow-1">
            <input type="text" id="OrganizationRef" className="form-control" />
          </div>
          <i className="fa fa-search mx-2"></i>
        </div>
      </div>

      {/* Organization */}
      <div className="col-md-6">
        <div className="card d-flex flex-row p-3 align-items-baseline">
          <label htmlFor="Organization" className="form-label mx-2">Organization</label>
          <div className="flex-grow-1">
            <input type="text" id="Organization" className="form-control" />
          </div>
          <i className="fa fa-search mx-2"></i>
          <i className="fa fa-plus-circle mx-2"></i>
        </div>
      </div>

      {/* Job Owner */}
      <div className="col-md-6">
        <div className="card d-flex flex-row p-3 align-items-baseline">
          <label htmlFor="JobOwner" className="form-label mx-2">Job Owner</label>
          <div className="flex-grow-1">
            <input
              type="text"
              id="JobOwner"
              className="form-control"
              value="Gyanender"
              readOnly
            />
          </div>
        </div>
      </div>

      {/* Sales Person */}
      <div className="col-md-6">
        <div className="card d-flex flex-row p-3 align-items-baseline">
          <label htmlFor="SalesPerson" className="form-label mx-2">Sales Person</label>
          <div className="flex-grow-1">
          <Select className="custom-selector ms-2 w-100" name="" placeholder="All" />

          </div>
        </div>
      </div>

      {/* Business Dimension */}
      <div className="col-md-6">
        <div className="card d-flex flex-row p-3 align-items-baseline">
          <label htmlFor="BusinessDimension" className="form-label mx-2">
            Business Dimension
          </label>
          <Select className="custom-selector ms-2 w-100" name="" placeholder="All" />

        </div>
      </div>

      {/* Tracking No. */}
      <div className="col-md-6">
        <div className="card d-flex flex-row p-3 align-items-baseline">
          <label htmlFor="TrackingNo" className="form-label mx-2">Tracking No.</label>
          <div className="flex-grow-1">
            <input type="text" id="TrackingNo" className="form-control" />
          </div>
        </div>
      </div>

      {/* Date */}
      <div className="col-md-6">
        <div className="card d-flex flex-row p-3 align-items-baseline">
          <label htmlFor="date" className="form-label mx-2">Date</label>
          <div className="flex-grow-1">
            <input type="date" id="date" className="form-control" />
          </div>
        </div>
      </div>

      {/* Narration */}
      <div className="col-md-12">
        <div className="card d-flex flex-column p-3">
          <label htmlFor="Narration" className="form-label">Narration</label>
          <textarea id="Narration" className="form-control" rows="3"></textarea>
        </div>
      </div>
    </div>




                    

                </div>
            </div>
        </div>
        <div className="row justify-content-end mt-3 gap-2">
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & Close
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & New
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Close
            </button>

        </div>
    </form>
</>
)
}

export default EntityTab